import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import useBills from "../hooks/useBills";
import BillGrid from "../shared/BillGrid";

const BillPage: React.FC = () => {
  const { data, status } = useBills();
  return (
    <BillGrid data={data?.index} status={status} />

  );
};
export default withAuthenticationRequired(BillPage);
